import { render, staticRenderFns } from "./add-attachment.vue?vue&type=template&id=62ec8df2&scoped=true&"
import script from "./add-attachment.vue?vue&type=script&lang=js&"
export * from "./add-attachment.vue?vue&type=script&lang=js&"
import style0 from "./add-attachment.vue?vue&type=style&index=0&id=62ec8df2&prod&lang=scss&scoped=true&"
import style1 from "./add-attachment.vue?vue&type=style&index=1&id=62ec8df2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec8df2",
  null
  
)

export default component.exports